import React, { useState } from "react";

import { ReactComponent as Close } from "../../../assets/icons/close_black_24dp.svg";

import User from "./AddUsersTenant.module.scss";
import { Constants } from "../../../config/Constants";
import config from "../../../config/aws-exports";
import { API } from "aws-amplify";
import swal from "sweetalert";

import CircularProgress from "@mui/material/CircularProgress";
import { getCountryCodes } from "./ContryCodes.jsx";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//     heigth: "100%",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "transparent",
//   },
// }));

const EditUser = (props) => {
  let { handleEditClose, getUsers, editData } = props;
  console.log("editData==", editData);
  const [userNameErr, setUserNameErr] = useState("");
  const [lastNameErr, setLastNameErr] = useState("");

  const [emailErr, setEmailErr] = useState("");
  const [pnoErr, setPnoErr] = useState("");
  const [genderErr, setGenderErr] = useState("");

  const [desigErr, setDesigErr] = useState("");
  const [departErr, setDepartErr] = useState("");
  const [orgErr, setOrgErr] = useState("");
  const [countryErr, setCountryErr] = useState("");
  const [cityErr, setCityErr] = useState("");
  const [stateErr, setStateErr] = useState("");
  const [pinErr, setPinErr] = useState("");
  const [stdErr, setStdErr] = useState("");
  const [addressErr, setAddressErr] = useState("");

  const [spin, setSpin] = useState(false);
  //const classes = useStyles();
  const [initialTenant] = useState(editData.col3);
  const [userName, setUserName] = useState(editData.firstname);
  const [lastName, setLastName] = useState(editData.lastname);
  const [email] = useState(editData.col2);
  const [pno, setPno] = useState(editData.cno);
  const [gender, setGender] = useState(editData.gen);
  const [address, setAddress] = useState(editData.busines_unit);
  const [urole] = useState(editData.userrole);
  const [country, setCountry] = useState(editData.country);

  // const [loading, setLoading] = useState(false);

  const [designation, setDesignation] = useState(editData.designation);
  const [department, setDepartment] = useState(editData.department);
  const [organization, setOrganization] = useState(editData.organization);
  const [city, setCity] = useState(editData.city);
  const [pin, setPin] = useState(editData.pin);
  const [state, setState] = useState(editData.state);
  const [std, setStd] = useState(editData.stdcode);
  const [gst, setGst] = useState(
    (editData.gstnumber !== "null" || editData.gstnumber !== null) &&
      editData.gstnumber !== undefined
      ? editData.gstnumber
      : "",
  );

  const [pan, setPan] = useState(
    editData.pan !== "null" &&
      editData.pan !== null &&
      editData.pan !== undefined
      ? editData.pan
      : "",
  );

  const onChangeHandlerUser = (event) => {
    setUserName(event.target.value);
  };

  const onChangeHandlerLastName = (event) => {
    setLastName(event.target.value);
  };

  // const onChangeHandlerEmail = (event) => {
  //   setEmail(event.target.value);
  // };
  // const onChangeHandlerPno = (event) => {
  //   setPno(event.target.value);
  // };
  const onChangeHandlerGender = (event) => {
    setGender(event.target.value);
  };
  const onChangeHandlerAddress = (event) => {
    setAddress(event.target.value);
    console.log("address", address);
  };
  const onChangeHandlerCountry = (e) => {
    setCountry(e.target.value);
  };

  // const onChangeHandlerUrole = (event) => {
  //   setUrole(event.target.value);
  // };
  // const onChangeHandlerUrole = (event) => {
  //   setUrole(event.target.value);
  // };

  // useEffect(() => {
  //   console.log("editData", editData);
  //   }, []);

  const onChangeHandlerDesignation = (e) => setDesignation(e.target.value);
  const onChangeHandlerDepartment = (e) => setDepartment(e.target.value);
  const onChangeHandlerOrganization = (e) => setOrganization(e.target.value);
  const onChangeHandlerCity = (e) => setCity(e.target.value);
  const onChangeHandlerPin = (e) => setPin(e.target.value);
  const onChangeHandlerState = (e) => setState(e.target.value);
  const onChangeHandlerStd = (e) => setStd(e.target.value);
  const onChangeHandlerGST = (e) => setGst(e.target.value);
  const onChangeHandlerPAN = (e) => setPan(e.target.value);
  const onChangeHandlerPhone = (e) => {
    setPno(e.target.value);
  };
  const onsubmit = () => {
    let formIsValid = true;
    setUserNameErr("");
    setLastNameErr("");
    setEmailErr("");
    setPnoErr("");
    setGenderErr("");
    setDesigErr("");
    setDepartErr("");
    setOrgErr("");
    setCountryErr("");
    setCityErr("");
    setPinErr("");
    setStdErr("");
    setStateErr("");
    setAddressErr("");

    if (
      userName === "" ||
      userName === null ||
      (userName !== undefined && userName.trim() === "")
    ) {
      formIsValid = false;
      setUserNameErr("Please enter first name");
      return;
    }
    if (
      lastName === "" ||
      lastName === null ||
      (lastName !== undefined && lastName.trim() === "")
    ) {
      formIsValid = false;
      setLastNameErr("Please enter Last name");
      return;
    }
    if (
      email === "" ||
      email === null ||
      (email !== undefined && email.trim() === "")
    ) {
      formIsValid = false;
      setEmailErr("*Please enter your email-ID.");
      return;
    }
    // if (
    //   pno !== null &&
    //   pno !== undefined &&
    //   pno.trim() !== '' &&
    //   pno.length < 10
    // ) {
    //   formIsValid = false;
    //   setPnoErr(
    //     'Please enter a valid phone number (should be atleast 10 digits)',
    //   );
    //   return;
    // }

    if (
      std === null ||
      std === undefined ||
      std.toString().trim() === "" ||
      std.toString().trim().length < 2 // most codes are at least 2 chars like "+1"
    ) {
      formIsValid = false;
      setStdErr("Please select a valid STD  code");
      return;
    }

    if (
      pno === null ||
      pno === undefined ||
      pno.toString().trim() === "" ||
      pno.toString().trim().length < 10
    ) {
      formIsValid = false;
      setPnoErr(
        "Please enter a valid phone number (should be atleast 10 digits)",
      );
      return;
    }
    if (gender === null) {
      formIsValid = false;
      setGenderErr("Please select gender");
      return;
    }
    if (userName !== "") {
      if (!userName.match(/^[a-zA-Z ]*$/)) {
        formIsValid = false;
        setUserNameErr("*Please enter alphabet characters only.");
        return;
      }
    }
    if (email !== "") {
      //regular expression for email validation
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
      );
      if (!pattern.test(email)) {
        formIsValid = false;
        setEmailErr("*Please enter valid email-ID.");
        return;
      }
    }

    if (
      designation === "" ||
      designation === null ||
      (designation !== undefined && designation.trim() === "")
    ) {
      formIsValid = false;
      setDesigErr("Please enter Designation");
      return;
    }

    if (
      department === "" ||
      department === null ||
      (department !== undefined && department.trim() === "")
    ) {
      formIsValid = false;
      setDepartErr("Please enter Department");
      return;
    }

    if (
      organization === "" ||
      organization === null ||
      (organization !== undefined && organization.trim() === "")
    ) {
      formIsValid = false;
      setOrgErr("Please enter Organization");
      return;
    }

    if (
      country === "" ||
      country === null ||
      (country !== undefined && country.trim() === "")
    ) {
      formIsValid = false;
      setCountryErr("Please Enter Country");
      return;
    }

    if (
      city === "" ||
      city === null ||
      (city !== undefined && city.trim() === "")
    ) {
      formIsValid = false;
      setCityErr("Please enter City");
      return;
    }
    if (
      pin === "" ||
      pin === null ||
      (pin !== undefined && pin.trim() === "")
    ) {
      formIsValid = false;
      setPinErr("Please Enter Pin");
      return;
    }

    if (
      state === "" ||
      state === null ||
      (state !== undefined && state.trim() === "")
    ) {
      formIsValid = false;
      setStateErr("Please enter State");
      return;
    }

    if (
      address === "" ||
      address === null ||
      (address !== undefined && address.trim() === "")
    ) {
      formIsValid = false;
      setAddressErr("Please enter Address");
      return;
    }

    if (formIsValid === true) {
      Updateuser();
    }
  };

  async function Updateuser() {
    setSpin(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        ur_id: editData.ur_id,
        tenant: initialTenant,
        emailid: editData.col2,
        first_name: userName,
        last_name: lastName,
        dev: editData.dev,
        urole: urole,
        gen: parseInt(gender),

        designation: designation,
        department: department,
        organization: organization,
        country: country,
        city: city,
        pin: pin === "" ? null : pin, // Converting to null if empty
        state: state,
        std: std, // Country Code (from the dropdown)
        pno: pno, // Phone Number (from the input field)
        gst: gst,
        pan: pan,
        officeAddress: address,
        schema: Constants.SCHEMA_NAME,
        cno: pno,
        type: "edit",
        atype: 1,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    console.log("bd" + JSON.stringify(bodyParam.body));
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.ADD_USER,
        bodyParam,
        //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
      );
      // const users = response;
      console.log("response", JSON.stringify(response));
      handleEditClose();
      getUsers();
      swal({
        title: "Success",
        text: response.message,
        icon: "success",
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          setSpin(false);
        }
      });
    } catch (error) {
      setSpin(false);
      swal({
        title: "Oooops!",
        text: "Something went wrong!",
        icon: "warning",
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          setSpin(false);
        }
      });
      console.log("getUserError", error);
    }
    console.log("Mount");
  }

  return (
    <div className={User.maindiv}>
      {spin === false ? (
        <div className={User.maincontainer}>
          <div className={User.iconcontainer}>
            <h3 className={User.create}>Edit user</h3>
            <Close className={User.closebutton} onClick={handleEditClose} />
          </div>

          {/* Container with Scroll and Grid Layout */}
          <div className={User.formContainer}>
            {/* First Name */}
            <div className={User.formGroup}>
              <label className={User.label}>
                First Name <span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type="text"
                onChange={onChangeHandlerUser}
                value={userName}
                required
              />
              <div className={User.errorMessage}>{userNameErr}</div>
            </div>

            {/* Last Name */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Last Name <span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type="text"
                onChange={onChangeHandlerLastName}
                value={lastName}
                required
              />
              <div className={User.errorMessage}>{lastNameErr}</div>
            </div>

            {/* Email */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Email <span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type="email"
                //onChange={onChangeHandlerEmail}
                value={email}
                required
              />
              <div className={User.errorMessage}>{emailErr}</div>
            </div>

            {/* Ph. No */}
            {/* STD & Phone Number - COMBINED GROUP */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Phone Number <span className={User.required}>*</span>
              </label>
              <div className={User.flexRow}>
                {/* STD Dropdown using imported function */}
                <select
                  className={`${User.input} ${User.inputSmall}`}
                  onChange={onChangeHandlerStd}
                  value={std ?? ""}
                >
                  <option value="" disabled>
                    STD
                  </option>
                  {getCountryCodes().map((item, index) => (
                    <option key={index} value={item.code}>
                      {item.code} ({item.country})
                    </option>
                  ))}
                </select>

                {/* Phone Input */}
                <input
                  className={User.input}
                  type="number"
                  placeholder="Phone Number"
                  onChange={onChangeHandlerPhone}
                  value={pno}
                />
              </div>
              {(stdErr || pnoErr) && (
                <div className={User.errorMessage}>
                  {stdErr && pnoErr
                    ? "Please select STD and enter phone number"
                    : stdErr || pnoErr}
                </div>
              )}
            </div>

            {/* Gender */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Gender<span className={User.required}>*</span>
              </label>
              <select
                className={User.input}
                onChange={onChangeHandlerGender}
                value={gender}
              >
                <option value="0">Select</option>
                <option value="1">Male</option>
                <option value="2">Female</option>
              </select>
              <div className={User.errorMessage}>{genderErr}</div>
            </div>

            {/* User Role */}
            <div className={User.formGroup}>
              <label className={User.label}>
                User Role <span className={User.required}>*</span>
              </label>
              <select
                className={User.input}
                //onChange={onChangeHandlerUrole}
                value={urole}
              >
                <option value="User">Participant</option>
                <option value="Manager">Manager</option>
              </select>
              <div className={User.errorMessage}></div>
            </div>

            {/* Designation */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Designation <span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type="text"
                onChange={onChangeHandlerDesignation}
                value={designation}
              />
              <div className={User.errorMessage}>{desigErr}</div>
            </div>

            {/* Department */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Department<span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type="text"
                onChange={onChangeHandlerDepartment}
                value={department}
              />
              <div className={User.errorMessage}>{departErr}</div>
            </div>

            {/* Organization */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Organization<span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type="text"
                onChange={onChangeHandlerOrganization}
                value={organization}
              />
              <div className={User.errorMessage}>{orgErr}</div>
            </div>

            <div className={User.formGroup}>
              <label className={User.label}>
                Country<span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type="text"
                onChange={onChangeHandlerCountry}
                value={country}
              />
              <div className={User.errorMessage}>{countryErr}</div>
            </div>

            {/* City */}
            <div className={User.formGroup}>
              <label className={User.label}>
                City<span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type="text"
                onChange={onChangeHandlerCity}
                value={city}
              />
              <div className={User.errorMessage}>{cityErr}</div>
            </div>

            {/* PIN */}
            <div className={User.formGroup}>
              <label className={User.label}>
                PIN Code<span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type="number"
                onChange={onChangeHandlerPin}
                value={pin}
              />
              <div className={User.errorMessage}>{pinErr}</div>
            </div>

            {/* State */}
            <div className={User.formGroup}>
              <label className={User.label}>
                State <span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type="text"
                onChange={onChangeHandlerState}
                value={state}
              />
              <div className={User.errorMessage}>{stateErr}</div>
            </div>

            {/* STD Phone */}
            {/* <div className={User.formGroup}>
                <label className={User.label}>STD Phone</label>
                <input
                  className={User.input}
                  type='number'
                  onChange={onChangeHandlerStd}
                  value={std}
                />
                <div className={User.errorMessage}></div>
              </div> */}

            {/* GST Number */}
            <div className={User.formGroup}>
              <label className={User.label}>GST Number</label>
              <input
                className={User.input}
                type="text"
                onChange={onChangeHandlerGST}
                value={gst}
              />
              <div className={User.errorMessage}></div>
            </div>

            {/* Company PAN */}
            <div className={User.formGroup}>
              <label className={User.label}>Company PAN</label>
              <input
                className={User.input}
                type="text"
                onChange={onChangeHandlerPAN}
                value={pan}
              />
              <div className={User.errorMessage}></div>
            </div>

            {/* Address - Full Width */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Office Address <span className={User.required}>*</span>
              </label>
              <textarea
                className={User.textarea}
                rows="3"
                onChange={onChangeHandlerAddress}
                value={address}
              />
              <div className={User.errorMessage}>{addressErr}</div>
            </div>

            {/* Office Address - Full Width */}
            {/* <div className={User.formGroup}>
                <label className={User.label}>
                  Office Address <span className={User.required}>*</span>
                </label>
                <textarea className={User.textarea} rows='3' />
                <div className={User.errorMessage}></div>
              </div> */}

            {/* Buttons */}
            <div className={User.buttonContaineredituser}>
              <button className={User.cancel} onClick={handleEditClose}>
                Cancel
              </button>
              <button type="submit" onClick={onsubmit} className={User.submit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={User.root}>
          <CircularProgress style={{ color: config.main_color_1 }} />
        </div>
      )}
    </div>
  );
};

export default EditUser;
